export default {
	zhifujieguoyanzhengzhong: 'The payment result is currently being verified, please be patient and wait.',
	zhengzaiweininchaxun: 'We are currently checking for you. Thank you for your patience',
	qingshuruhuoxuanzenidechengshi: 'Please enter or select your destination!',
	qingshuruchufadidian: 'Please Input the departure location!',
	qingshurumudidi: 'Please Input  the destination!',
	qinglijiyuwomenlianxin: 'Get in touch with us today for any inquiries or assistance with your bookings.',
	lijiyuwomenliaotian: 'Chat with Us Now',
	kehufuwurexian: 'Customer Service Hotline',
	xuyaobangzhuma: 'Need Help？',
	geiwomenfadianziyoujian: 'Email Us',
	chaxunbiaoge: 'Contact Form',
	songxinren: 'Messenger',
	xingming: 'Full Name',
	gongsimingcheng: 'Company Name',
	youjiandizhi: 'Email Address',
	lianxidianhua: 'Contact Number',
	zhuti: 'Subject',
	liuyan: 'Message',
	tijiao: 'Submit',
	lianxiwomen: 'Contact Us',
	shouyetishixinxi: '* Prices listed above are for return flights of economy class only. Actual price may vary. Terms and conditions apply.',
	shangyiye: 'Prev',
	xiayiye: 'Next',
	fangda: 'Amplify',
	suoxiao: 'Reduce',
	shengdantishi: 'Failed to submit order, return to search results page and search again',
	qushouye: 'Go To The Homepage',
	hangbanyishouqing: 'The Flight Is Sold Out',
	zhifushibai: 'Payment Failed',
	zhifuchaoshi: 'Payment Timeout',
	chongxinzhifu: 'Repayment',
	yudingshibai: 'Booking Failed!',
	dingdanzhengzaichulizhong: 'The order is currently being processed, please refresh and check the status later!',
	yiwancheng: 'Completed',
	zhifufangshi: ' Payment Method',
};
